<template>
  <div class="Leafs">
    <svg
      version="1.1"
      id="Warstwa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 710 710"
      enable-background="new 0 0 710 710"
      xml:space="preserve"
    >
      <g>
        <path
          opacity="0.2"
          fill="#FFFFFF"
          d="M355,672.5C179.6,672.5,37.5,530.4,37.5,355C212.8,355,355,497.2,355,672.5z"
        />
        <path
          opacity="0.2"
          fill="#FFFFFF"
          d="M355,37.5c175.4,0,317.5,142.2,317.5,317.5C497.2,355,355,212.8,355,37.5z"
        />
        <path
          opacity="0.2"
          fill="#FFFFFF"
          d="M37.5,355C37.5,179.6,179.6,37.5,355,37.5C355,212.8,212.8,355,37.5,355z"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "Leafs",
};
</script>
